<template>
  <div class="material-preview">
    <div class="material-preview-head">
      <div class="material-preview-title">
        <strong>素材预览</strong>
        <el-tag v-for="tag in materialTags" :key="tag" size="mini" class="preview-tag">{{ tag }}</el-tag>
      </div>
      <el-tag size="mini" type="success">{{ material.sourceType }}</el-tag>
    </div>

    <div class="preview-grid">
      <div class="preview-section">
        <div class="summary-label">主图预览</div>
        <div class="preview-thumbs">
          <div
            v-for="image in material.mainImages"
            :key="image.id"
            class="preview-thumb"
            role="button"
            tabindex="0"
            @click="openImagePreview(image)"
            @keydown.enter="openImagePreview(image)"
          >
            <el-image :src="image.url" fit="cover" class="preview-thumb-image" />
            <div class="preview-thumb-text">
              <span>{{ image.productModel }}</span>
              <span>{{ image.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="preview-section">
        <div class="summary-label">详情长图预览</div>
        <div
          class="detail-preview"
          role="button"
          tabindex="0"
          @click="openImagePreview(material.detailImage)"
          @keydown.enter="openImagePreview(material.detailImage)"
        >
          <el-image :src="material.detailImage.url" fit="cover" class="detail-preview-image" />
          <div class="detail-preview-mask">
            <div>{{ material.detailImage.title }}</div>
            <div>{{ material.detailImage.type }}</div>
            <div>{{ material.detailImage.description }}</div>
          </div>
        </div>
      </div>

      <div class="preview-section preview-section-sku">
        <div class="summary-label">销售属性图预览</div>
        <div class="preview-thumbs compact">
          <div
            v-for="image in material.skuImages"
            :key="image.id"
            class="preview-thumb sku"
            role="button"
            tabindex="0"
            @click="openImagePreview(image)"
            @keydown.enter="openImagePreview(image)"
          >
            <el-image :src="image.url" fit="cover" class="preview-thumb-image" />
            <span class="sku-name">{{ image.name }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="material-path" :title="material.path">{{ material.path }}</div>

    <el-dialog
      title="图片预览"
      :visible.sync="imageDialogVisible"
      width="760px"
      append-to-body
      destroy-on-close
    >
      <div class="image-preview-content">
        <img v-if="activeImage.url" :src="activeImage.url" :alt="activeImage.name || activeImage.title" class="preview-large-image">
        <div v-if="activeImage.name || activeImage.title" class="preview-large-name">{{ activeImage.name || activeImage.title }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const propImagePrefix = 'https://img.alicdn.com/imgextra/'

export default {
  name: 'MaterialPreview',
  data () {
    return {
      imageDialogVisible: false,
      activeImage: {},
      material: {
        productModel: '122717',
        materialType: '老品优化',
        imageCount: 214,
        sourceType: '标准源素材包',
        mainImages: [
          {
            id: 'main-1',
            productModel: '122717',
            name: '主图1',
            url: 'https://img.alicdn.com/imgextra/i1/685563493/O1CN01qbnnTVC2oaC2vH2e_!!685563493.jpg'
          },
          {
            id: 'main-2',
            productModel: '122717',
            name: '主图2',
            url: 'https://img.alicdn.com/imgextra/i4/685563493/O1CN01TpsvCLR7UeF2vH2e_!!685563493.jpg'
          },
          {
            id: 'main-3',
            productModel: '122717',
            name: '主图3',
            url: 'https://img.alicdn.com/imgextra/i2/685563493/O1CN01hzCQWxqyALH2vH2e_!!685563493.jpg'
          },
          {
            id: 'main-4',
            productModel: '122717',
            name: '主图4',
            url: 'https://img.alicdn.com/imgextra/i4/685563493/O1CN01XcAcCYBchFG2vH2e_!!685563493.jpg'
          },
          {
            id: 'main-5',
            productModel: '122717',
            name: '主图5',
            url: 'https://img.alicdn.com/imgextra/i2/685563493/O1CN01Tzr30FUXRjH2vH2e_!!685563493.jpg'
          }
        ],
        detailImage: {
          id: 'detail-1',
          title: '122717茶几电视柜组合-老品优化版',
          type: '卖点图 / 场景图 / 尺寸图 / 材质图',
          description: '未切片详情长图，尺寸以实际文件为准',
          url: 'https://img.alicdn.com/imgextra/i1/685563493/O1CN01FekQ9FBwK0J2vHAO_!!685563493.jpg'
        },
        skuImages: [
          {
            id: 'sku-1',
            name: '122717茶几+122717电视柜',
            url: `${propImagePrefix}i1/685563493/O1CN01dBD7WiYhQlG1chua_!!685563493.jpg`
          },
          {
            id: 'sku-2',
            name: '122717电视柜',
            url: `${propImagePrefix}i4/685563493/O1CN01RxEhH6iY0PJ1chua_!!685563493.jpg`
          },
          {
            id: 'sku-3',
            name: '122717茶几（指定地区7天发货）',
            url: `${propImagePrefix}i4/685563493/O1CN01n5lp8BVmjwB1chua_!!685563493.jpg`
          },
          {
            id: 'sku-4',
            name: '122717茶几+122717电视柜+边柜',
            url: `${propImagePrefix}i4/685563493/O1CN01xZPErAkv2GC1chua_!!685563493.jpg`
          },
          {
            id: 'sku-5',
            name: '122717茶几+电视柜（指定地区7天发货）',
            url: `${propImagePrefix}i4/685563493/O1CN01Z68S1xRirZG1chua_!!685563493.jpg`
          },
          {
            id: 'sku-6',
            name: '122717二件套',
            url: `${propImagePrefix}i1/685563493/O1CN01ZtWWRsWLP9J1chua_!!685563493.jpg`
          }
        ],
        path: '\\\\dzfileserver\\data\\dsgl-file-stg\\新品上架\\切片\\新\\老品优化\\122717\\2026-07-02\\122717茶几电视柜组合'
      }
    }
  },
  computed: {
    materialTags () {
      return [
        this.material.productModel,
        this.material.materialType,
        `图片 ${this.material.imageCount} 张`
      ]
    }
  },
  methods: {
    openImagePreview (image) {
      this.activeImage = image
      this.imageDialogVisible = true
    }
  }
}
</script>

<style lang="stylus" scoped>
.material-preview
  margin-top 12px
  padding 14px
  border 1px solid #ebeef5
  border-radius 6px
  background #fff

.material-preview-head
  display flex
  align-items center
  justify-content space-between
  gap 12px
  margin-bottom 16px

.material-preview-title
  display flex
  align-items center
  flex-wrap wrap
  gap 8px
  color #303133

.preview-tag
  margin-left 2px

.preview-grid
  display grid
  grid-template-columns minmax(0, 1fr) minmax(220px, 1.1fr) minmax(0, 1.2fr)
  gap 16px

.preview-section
  min-width 0

.summary-label
  margin-bottom 8px
  color #606266
  font-size 12px
  font-weight 600

.preview-thumbs
  display grid
  grid-template-columns repeat(5, minmax(0, 1fr))
  gap 8px

.preview-thumbs.compact
  grid-template-columns repeat(3, minmax(0, 1fr))

.preview-thumb
  position relative
  min-width 0
  height 112px
  overflow hidden
  border 1px solid #dcdfe6
  border-radius 4px
  background #f5f7fa
  cursor pointer
  outline none

.preview-thumb:hover,
.preview-thumb:focus
  border-color #409eff
  box-shadow 0 0 0 1px rgba(64, 158, 255, .15)

.preview-thumb-image
  display block
  width 100%
  height 100%

.preview-thumb-image >>> .el-image__inner
  width 100%
  height 100%

.preview-thumb-text
  position absolute
  right 0
  bottom 0
  left 0
  display flex
  flex-direction column
  padding 4px 5px
  color #fff
  background rgba(0, 0, 0, .55)
  font-size 11px
  line-height 16px
  text-align center

.preview-thumb-text span
  overflow hidden
  text-overflow ellipsis
  white-space nowrap

.preview-thumb.sku
  height 92px

.sku-name
  position absolute
  right 0
  bottom 0
  left 0
  overflow hidden
  padding 4px 5px
  color #fff
  background rgba(0, 0, 0, .55)
  font-size 11px
  line-height 16px
  text-overflow ellipsis
  white-space nowrap

.detail-preview
  position relative
  height 244px
  overflow hidden
  border 1px solid #dcdfe6
  border-radius 4px
  background #f5f7fa
  cursor pointer
  outline none

.detail-preview:hover,
.detail-preview:focus
  border-color #409eff
  box-shadow 0 0 0 1px rgba(64, 158, 255, .15)

.detail-preview-image
  display block
  width 100%
  height 100%

.detail-preview-image >>> .el-image__inner
  width 100%
  height 100%

.detail-preview-mask
  position absolute
  right 0
  bottom 0
  left 0
  padding 10px
  color #fff
  background linear-gradient(transparent, rgba(0, 0, 0, .78))
  font-size 12px
  line-height 20px

.detail-preview-mask div
  overflow hidden
  text-overflow ellipsis
  white-space nowrap

.material-path
  margin-top 16px
  padding: 8px 10px
  overflow hidden
  border-radius 4px
  color #606266
  background #f5f7fa
  font-size 12px
  line-height 18px
  text-overflow ellipsis
  white-space nowrap

.image-preview-content
  text-align center

.preview-large-image
  display block
  max-width 100%
  max-height 65vh
  margin 0 auto

.preview-large-name
  margin-top 10px
  color #606266
  font-size 13px
  word-break break-all

@media (max-width: 1200px)
  .preview-grid
    grid-template-columns 1fr 1fr

  .preview-section-sku
    grid-column 1 / -1

@media (max-width: 760px)
  .material-preview-head,
  .preview-grid
    display block

  .material-preview-head > .el-tag
    display inline-block
    margin-top 8px

  .preview-section
    margin-bottom 16px

  .detail-preview
    height 220px
</style>
